module.exports = __webpack_public_path__ + "static/media/meh.ca6c100a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/meh.png
// module id = 1721
// module chunks = 0